import { render, staticRenderFns } from "./wqt-step-4b.vue?vue&type=template&id=f1cd5a96&"
import script from "./wqt-step-4b.vue?vue&type=script&lang=js&"
export * from "./wqt-step-4b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports